import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { trackEvent } from '@utils/mixpanel';
import { SUCCESS } from '@constants/requestPhase';
import { getAdminCompanyById, resetPhases } from '@store/company/duck';

import { TeamOnboarding as View } from '@views';

const TeamOnboarding = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user } = useSelector(store => store.userStore);
  const {
    updateCompanyMemberPhase,
    createCompanyMemberPhase,
    adminCompanyById,
    companyMembersByAccessId: { data, pagination },
  } = useSelector(store => store.companyStore);

  useEffect(() => {
    const pageTitle = 'Mindspace: Register Your Team';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Team - Onboarding',
    });
  }, []);

  useEffect(() => {
    if (
      (!adminCompanyById?.activeMembers && user.company) ||
      updateCompanyMemberPhase === SUCCESS ||
      createCompanyMemberPhase === SUCCESS
    ) {
      dispatch(resetPhases());
      dispatch(getAdminCompanyById(user.company.id));
    }
  }, [adminCompanyById?.name, user.company, updateCompanyMemberPhase, createCompanyMemberPhase]);

  return (
    <View
      direction={location?.state?.direction}
      activeMembers={pagination?.total}
      companyStatus={adminCompanyById?.status}
      companyName={adminCompanyById?.name}
      companyMembers={data}
      pagination={pagination}
    />
  );
};

export default TeamOnboarding;
